import {
  editHolidayApiCall,
  getHolidaysApiRequest,
  getResourceHolidaysApiRequest,
  removeHolidayApiRequest,
  removeResourceFromHolidayApiRequest,
  saveHolidayApiCall,
  saveHolidayRepeatApiCall,
} from '@guryou/api-client-gql';
import { parseDate } from '@guryou/utils';

import { PERSONNEL_HOLIDAY_CREATE, PERSONNEL_HOLIDAY_DELETE, PERSONNEL_HOLIDAY_UPDATE, PERSONNEL_HOLIDAYS_GET_MANY } from '../new/resource';
import { HOLIDAYS_GET_MANY } from '../types';

import { execute } from './actionWrapper';

const saveHoliday = data => async dispatch => {
  const startTime = parseDate(`${data.startDate}T${data.startTime}:00`).toISOString();
  const endTime = parseDate(`${data.endDate}T${data.endTime}:00`).toISOString();
  return execute(
    dispatch,
    () =>
      saveHolidayApiCall({
        startTime,
        endTime,
        description: data.description,
        resources: !data.resources ? null : Array.isArray(data.resources) ? data.resources.map(x => +x) : [+data.resources],
      }),
    PERSONNEL_HOLIDAY_CREATE
  );
};

const saveHolidayRepeat = data => async dispatch => {
  const startTime = parseDate(`${data.startDate}T${data.startTime}:00`).toISOString();
  const endTime = parseDate(`${data.endDate}T${data.endTime}:00`).toISOString();
  return execute(
    dispatch,
    () =>
      saveHolidayRepeatApiCall({
        startTime,
        endTime,
        description: data.description,
        resources: !data.resources ? null : Array.isArray(data.resources) ? data.resources.map(x => +x) : [+data.resources],
      }),
    PERSONNEL_HOLIDAY_CREATE
  );
};

const editHoliday = data => async dispatch => {
  const startTime = parseDate(`${data.startDate}T${data.startTime}:00`).toISOString();
  const endTime = parseDate(`${data.endDate}T${data.endTime}:00`).toISOString();
  return execute(
    dispatch,
    () =>
      editHolidayApiCall({
        id: data.id,
        startTime,
        endTime,
        description: data.description,
        resources: !data.resources ? [] : Array.isArray(data.resources) ? data.resources.map(x => +x) : [+data.resources],
        modifyResources: data.modifyResources,
      }),
    PERSONNEL_HOLIDAY_UPDATE
  );
};
const removeHoliday = holidayId => async dispatch => execute(dispatch, () => removeHolidayApiRequest(holidayId), PERSONNEL_HOLIDAY_DELETE);

const removeResourceFromHoliday = (holidayId, resourceId) => async dispatch =>
  execute(dispatch, () => removeResourceFromHolidayApiRequest(holidayId, resourceId), PERSONNEL_HOLIDAY_DELETE);

const getResourceHolidays = resourceId => async dispatch =>
  execute(dispatch, () => getResourceHolidaysApiRequest(resourceId), PERSONNEL_HOLIDAYS_GET_MANY);

const getHolidays = () => async dispatch => execute(dispatch, () => getHolidaysApiRequest(), HOLIDAYS_GET_MANY);

export { editHoliday, getHolidays, getResourceHolidays, removeHoliday, removeResourceFromHoliday, saveHoliday, saveHolidayRepeat };
